export enum Environment {
  LocalDevelopment = 'dev',
  Cypress = 'cypress',

  // The values below are also defined in GCP.
  Staging = 'staging',
  Production = 'prod',
}
